module.exports = __webpack_public_path__ + "img/public_security_icon.d0289dc0.png";